(function () {
  "use strict";

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function initialiseCountdown(element) {
    var deadline = new Date(element.getAttribute("data-deadline"));
    if (Number.isNaN(deadline.getTime())) {
      return;
    }

    var days = element.querySelector("[data-tsas-sale-days]");
    var hours = element.querySelector("[data-tsas-sale-hours]");
    var minutes = element.querySelector("[data-tsas-sale-minutes]");
    var message = element.querySelector(".tsas-sale-deadline__message");
    var timer = element.querySelector(".tsas-sale-deadline__timer");
    var timeoutId;

    function render() {
      var milliseconds = deadline.getTime() - Date.now();
      if (milliseconds <= 0) {
        element.classList.add("is-ended");
        if (message) {
          message.textContent = element.getAttribute("data-expired-label") || "Spring sale has ended";
        }
        if (timer) {
          timer.hidden = true;
        }
        return;
      }

      var totalMinutes = Math.floor(milliseconds / 60000);
      var remainingDays = Math.floor(totalMinutes / 1440);
      var remainingHours = Math.floor((totalMinutes % 1440) / 60);
      var remainingMinutes = totalMinutes % 60;
      if (days) days.textContent = pad(remainingDays) + "d";
      if (hours) hours.textContent = pad(remainingHours) + "h";
      if (minutes) minutes.textContent = pad(remainingMinutes) + "m";

      var delay = 60000 - (Date.now() % 60000) + 25;
      timeoutId = window.setTimeout(render, delay);
    }

    render();
    window.addEventListener("pagehide", function () {
      if (timeoutId) window.clearTimeout(timeoutId);
    }, { once: true });
  }

  function initialise() {
    document.querySelectorAll("[data-tsas-sale-deadline]").forEach(initialiseCountdown);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }
}());
